import { User } from 'firebase/auth';
import axios from 'axios';

import { Coupon } from '~/types/coupon';

const couponBaseUrl = process.env.REACT_APP_COUPON_URL || '';

const couponAxiosInstance = axios.create({
  baseURL: couponBaseUrl,
});

export async function getCoupons(platformId: string, auth: User): Promise<Array<Coupon>> {
  const token = await auth.getIdToken();
  const res = await couponAxiosInstance.get<{ results: Array<Coupon> }>(
    `/platforms/${platformId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return res.data.results;
}

export async function getCoupon(platformId: string, auth: User, id: string) {
  const token = await auth.getIdToken();
  const res = await couponAxiosInstance.get<Coupon>(`/platforms/${platformId}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
}
